import angular from 'angular';
import './api/donation';

angular.module('folkeuni').factory('Donation', function(DonationApi, $q) {
  var donation = this;
 
  donation.sendDonation = function(donationObj){
    var deferred = $q.defer();
    
    DonationApi.sendDonation(donationObj).then(function(response){       
        deferred.resolve(response.data);
    }, function(error){
        deferred.reject(error)
    })
    return deferred.promise;
  };

  donation.fetchRefundData = function(refundObj){
    var deferred = $q.defer();
    
    DonationApi.fetchRefundData(refundObj).then(function(response){       
        deferred.resolve(response.data);
    }, function(error){
        deferred.reject(error)
    })
    return deferred.promise;
  };

  return donation; 
});
    